import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from '@dev-go4ellis/go4-design-system';
import './Coverage.scss';

const ICONS = {
  verified: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2 4 5v6c0 5 3.4 8.5 8 10 4.6-1.5 8-5 8-10V5l-8-3Z" /><path d="m9 12 2 2 4-4" /></svg>,
  shield: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2 4 5v6c0 5 3.4 8.5 8 10 4.6-1.5 8-5 8-10V5l-8-3Z" /></svg>,
  doc: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></svg>,
  emergency: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"><path d="M10 3h4v5.13l4.44-2.56 2 3.46L16 11.6l4.44 2.57-2 3.46L14 15.07V20h-4v-4.93l-4.44 2.56-2-3.46L8 11.6 3.56 9.03l2-3.46L10 8.13V3Z" /></svg>,
};

const ITEMS = [
  { icon: 'verified', title: 'Verified licensure', body: 'State licensure and BOC certification are checked before a trainer can accept your job.' },
  { icon: 'shield', title: 'PLI included', body: 'Professional liability coverage applies to every shift worked through the platform.' },
  { icon: 'doc', title: 'HIPAA-compliant EMR', body: 'Injury reports, treatment logs and athlete histories are stored securely and stay with you.' },
  { icon: 'emergency', title: 'Emergency Action Plans', body: 'Generate venue-specific EAPs that satisfy most school and facility compliance requirements.' },
];

const Coverage = ({ onBackToEstimator }) => (
  <section id="trust" className="pl-coverage">
    <div className="pl-coverage__inner">
      <div className="pl-coverage__left">
        <div className="pl-coverage__eyebrow">Coverage &amp; compliance</div>
        <h2 className="pl-coverage__title">The fee is the risk work you'd otherwise do yourself</h2>
        <p className="pl-coverage__lead">Every trainer who accepts your job has been credential-checked, insured and paid through Go4. Documentation lands in your account, not in someone's glovebox.</p>
        <div className="pl-coverage__back-wrap">
          <Button variant="secondary" size="md" onClick={onBackToEstimator}>Back to the estimator</Button>
        </div>
      </div>
      <div className="pl-coverage__grid">
        {ITEMS.map((item) => (
          <Card key={item.title} padding="lg" flat className="pl-coverage__card">
            <span className="pl-coverage__icon">{ICONS[item.icon]}</span>
            <div className="pl-coverage__card-title">{item.title}</div>
            <p className="pl-coverage__card-body">{item.body}</p>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

Coverage.propTypes = {
  onBackToEstimator: PropTypes.func,
};

Coverage.defaultProps = {
  onBackToEstimator: () => {},
};

export default Coverage;
